import apiClient from './client';

export interface News {
  id: string;
  title: string;
  content: string;
  excerpt?: string;
  category?: 'announcement' | 'event' | 'achievement' | 'general';
  imageUrl?: string;
  isPinned: boolean;
  isPublished: boolean;
  viewCount: number;
  publishedAt?: string;
  createdBy: string;
  creator?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface GetNewsParams {
  page?: number;
  limit?: number;
  category?: string;
  isPublished?: boolean;
  search?: string;
}

export const newsAPI = {
  getNews: async (params?: GetNewsParams) => {
    const response = await apiClient.get('/news', { params });
    return response.data;
  },

  getNewsById: async (id: string) => {
    const response = await apiClient.get(`/news/${id}`);
    return response.data;
  },

  createNews: async (data: Partial<News>) => {
    const response = await apiClient.post('/news', data);
    return response.data;
  },

  updateNews: async (id: string, data: Partial<News>) => {
    const response = await apiClient.put(`/news/${id}`, data);
    return response.data;
  },

  deleteNews: async (id: string) => {
    const response = await apiClient.delete(`/news/${id}`);
    return response.data;
  },
};
